var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.LOGISTICS_COMPANY_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "baseForm",
              fn: function () {
                return [
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "businessLogisticsCompanyBusiness.table.abbreviation"
                            ),
                            prop: "name",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t(
                                "businessLogisticsCompanyBusiness.table.abbreviation"
                              ),
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleQuery.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.queryParams.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "name", $$v)
                              },
                              expression: "queryParams.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "businessLogisticsCompany.table.logisticsCompanyName2"
                            ),
                            prop: "companyId",
                          },
                        },
                        [
                          _c("BjSelectLogisticCompany", {
                            attrs: {
                              placeholder: _vm.$t(
                                "businessLogisticsCompany.table.logisticsCompanyName2"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryParams.companyId,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "companyId", $$v)
                              },
                              expression: "queryParams.companyId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCenter.zone"),
                            prop: "customerLogisticsGroupDictId",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder: _vm.$t("QuotationCenter.zone"),
                              "option-list": _vm.zoneGroupList,
                            },
                            on: { change: _vm.handleQuery },
                            model: {
                              value:
                                _vm.queryParams.customerLogisticsGroupDictId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams,
                                  "customerLogisticsGroupDictId",
                                  $$v
                                )
                              },
                              expression:
                                "queryParams.customerLogisticsGroupDictId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              "API " +
                              _vm.$t("businessLogisticsCompany.common.status"),
                            prop: "enableFlag",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder:
                                "API " +
                                _vm.$t(
                                  "businessLogisticsCompany.common.status"
                                ),
                              "option-list": _vm.STATUS_ENABLED_TRUE,
                            },
                            model: {
                              value: _vm.queryParams.enableFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "enableFlag", $$v)
                              },
                              expression: "queryParams.enableFlag",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              "CSG " +
                              _vm.$t("businessLogisticsCompany.common.status"),
                            prop: "csgEnableFlag",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder:
                                "CSG " +
                                _vm.$t(
                                  "businessLogisticsCompany.common.status"
                                ),
                              "option-list": _vm.STATUS_ENABLED_TRUE,
                            },
                            model: {
                              value: _vm.queryParams.csgEnableFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "csgEnableFlag", $$v)
                              },
                              expression: "queryParams.csgEnableFlag",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            !_vm.$store.getters.cusId
              ? {
                  key: "tableOperation",
                  fn: function () {
                    return [
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "main-btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.onAdd },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("businessLogisticsCompany.common.add")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "tableColumn",
              fn: function () {
                return [
                  _vm._l(_vm.dropCols, function (col, index) {
                    return [
                      col.prop !== "bjTableAction"
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || false,
                              align: "center",
                              "class-name": "item",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      false
                                        ? void 0
                                        : col.prop ===
                                          "customerLogisticsGroupDictId"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.zoneGroupList.bjGet(
                                                  scope.row
                                                    .customerLogisticsGroupDictId
                                                )
                                              )
                                            ),
                                          ])
                                        : col.prop === "enableFlag"
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: scope.row[col.prop]
                                                  ? "success"
                                                  : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.STATUS_ENABLED_TRUE.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : col.prop === "csgEnableFlag"
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: scope.row[col.prop]
                                                  ? "success"
                                                  : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.STATUS_ENABLED_TRUE.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : col.prop === "profitMargin"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.profitMargin) +
                                                "%"
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeFilters")(
                                                  scope.row[col.prop],
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                      col.prop === "bjTableAction" && !_vm.$store.getters.cusId
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || "right",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "el-dropdown",
                                        {
                                          directives: [
                                            {
                                              name: "hasDropdownChildren",
                                              rawName: "v-hasDropdownChildren",
                                            },
                                          ],
                                          on: {
                                            command: function ($event) {
                                              return _vm.command($event, row)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "el-dropdown-link" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "AccountManagement.common.operate"
                                                  )
                                                )
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-arrow-down el-icon--right",
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown",
                                            },
                                            [
                                              !row.enableFlag
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "apiOpen",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "API " +
                                                          _vm._s(
                                                            _vm.$t("enableText")
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              row.enableFlag
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "apiClose",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "API " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "disableText"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              !row.csgEnableFlag
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "csgOpen",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "CSG " +
                                                          _vm._s(
                                                            _vm.$t("enableText")
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              row.csgEnableFlag
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "csgClose",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "CSG " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "disableText"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  attrs: { command: "Setting" },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("settingText1")
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  attrs: { command: "showLog" },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("logText")) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c("DataForm", {
        ref: "DataForm",
        on: { reFresh: _vm.reFresh, batchDeleteApi: _vm.batchDeleteApi },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }